<template>
  <CCard>
    <CCardHeader>
      <div class="card-header-actions">
        <CButton variant="outline" color="success" @click="onReset" ref="reset-button" v-translate
                 translate-context="form" class="mr-2">Reset
        </CButton>
        <CButton color="primary" @click="onSave" ref="save-button">{{ save_text }}</CButton>
      </div>
    </CCardHeader>
    <CCardBody class="p-0">
      <CContainer fluid class="grid-stripped">
        <PFormRow>
          <template v-slot:firstColContent>
            {{ $pgettext('faq_question.label', 'Question') }}
          </template>
          <template v-slot:secondColContent>
            <PTranslatableTextInput v-model="form.question" :placeholder="$pgettext('faq_question.placeholder','Question')"/>
          </template>
        </PFormRow>
        <PFormRow>
          <template v-slot:firstColContent>
            {{ $pgettext('faq_question.label', 'Answer') }}
          </template>
          <template v-slot:secondColContent>
            <PTranslatableCkeditor
                v-model="form.answer"
                :placeholder="$pgettext('faq_question.placeholder','Answer')" />
          </template>
        </PFormRow>
        <PFormRow>
          <template v-slot:firstColContent>
            {{ $pgettext('faq_question.label', 'Tags') }}
          </template>
          <template v-slot:secondColContent>
            <PTagInput
                v-model="form.tags"
                :placeholder="$pgettext('faq_question.placeholder','Tags')"
                :autocomplete="autocomplete_tag"
            />
          </template>
        </PFormRow>
        <PFormRow>
          <template v-slot:firstColContent>
            {{ $pgettext('faq_question.label', 'Active') }}
          </template>
          <template v-slot:secondColContent>
            <CSwitch class="mx-1" color="primary"
                     variant="3d" size="sm"
                     :checked.sync="form.is_active"/>
          </template>
        </PFormRow>
        <PFormRow>
          <template v-slot:firstColContent>
            {{ $pgettext('faq_question.label', 'Order') }}
          </template>
          <template v-slot:secondColContent>
            <CInput
                v-model="form.order"
                ref="form-order"
                :placeholder="0"
            />
          </template>
        </PFormRow>
      </CContainer>
    </CCardBody>
  </CCard>

</template>

<script>
import PFormRow from "@/components/PFormRow.vue";
import PTranslatableTextInput from "@/domain/core/components/PTranslatableTextInput.vue";
import PTranslatableCkeditor from "@/domain/core/components/PTranslatableCkeditor.vue";
import PTagInput from "@/domain/core/components/PTagInput.vue";

export default {
  name: "QuestionForm",
  components: {PTagInput, PTranslatableCkeditor, PTranslatableTextInput, PFormRow},
  props: {
    data: {
      type: Object,
      required: true
    },
    save_text: {
      type: String,
      required: true
    },
    autocomplete_tag: {
      type: Function,
      required: true
    }
  },
  data() {
    return {
      form: {
        question: {},
        answer: {},
        order: 0,
        is_active: true,
      },
    }
  },
  mounted() {
    this.onReset()
  },
  emits: ['save'],
  methods: {
    onReset() {
      this.form = {...this.data}
    },
    async onSave() {
      this.$emit('save', this.form)
    },
  }
}
</script>

<style scoped>

</style>